"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStatEntity = void 0;
var chance_1 = require("../chance");
var chance = (0, chance_1.getChance)();
var createStatEntity = function () { return ({
    count: chance.natural(),
    value: chance.word(),
}); };
exports.createStatEntity = createStatEntity;
//# sourceMappingURL=_stat-entity.js.map